import React from 'react'
import {
  Link, useNavigate
} from "react-router-dom";

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';
import Drawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import Divider from '@mui/material/Divider'

const drawerWidth = 240;
const Navbar = (props) => {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };
  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <Typography variant="h6" sx={{ my: 2 }}>
        Memories
      </Typography>
      <Divider />
      <List>
      <ListItem disablePadding>
            <ListItemButton sx={{ textAlign: 'center' }} >
            <Button color="inherit"  > 
             <Link className="btn  text-black"  to="/login" role="button">Login</Link>
             </Button>
            </ListItemButton>
          </ListItem>
          <Divider />
          <ListItem disablePadding>
            <ListItemButton sx={{ textAlign: 'center' }}>
            <Button color="inherit" > 
             <Link className="btn   text-black" to="/signup" role="button">SignUp</Link>
             </Button>
            </ListItemButton>
          </ListItem>
          <Divider />
      </List>
    </Box>
  );
  let navigate = useNavigate();
  const handlelogout=()=>{
    handleClose();
    localStorage.removeItem('token');
    localStorage.removeItem('name');
    navigate('/login');
   props.showAlert("You are logged out successfully","success")
  }
  const [anchorEl, setAnchorEl] = React.useState(null);

  

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const container = window !== undefined ? () => window().document.body : undefined;
  return (
    <Box sx={{ display:'flex' }} >
       <AppBar position="static" style={{backgroundColor:"#1E52A8"}}>
       <Toolbar>
      {!localStorage.getItem('token')&&
       <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>}
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Memories
          </Typography>
           
           {
           !localStorage.getItem('token')? <form className="d-flex" >
          <Button  sx={{display:{xs:'none',sm:'block'},color:'blue'}} >  <Link className="btn mx-4 text-white"  to="/login" role="button">Login</Link></Button>
          <Button color="inherit" sx={{display:{xs:'none',sm:'block'}}} >  <Link className="btn  text-white" to="/signup" role="button">SignUp</Link></Button>
         
            </form>:  <div>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
              >
                <AccountCircle />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClick={handleClose}>{"Hello!!  " + localStorage.getItem('name')}</MenuItem>
                <MenuItem onClick={handlelogout}>Logout</MenuItem>
              </Menu>
            </div>
            }
          </Toolbar>
        </AppBar>
        <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    </Box>
  )
}

export default Navbar